import React, { useState } from 'react'
import { updateProfile } from 'firebase/auth'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import '../../global.css'

const SetDisplayName = () => {
  const [name, setName] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState('')
  
  const { user, completeSetup } = useAuth()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const handleContinue = async () => {
    if (!user) {
      setError('No hay usuario autenticado')
      return
    }

    setIsLoading(true)
    setError('')

    try {
      // Actualizar el displayName del usuario
      await updateProfile(user, {
        displayName: name.trim()
      })

      // Marcar que el usuario completó la configuración
      completeSetup()

      // Verificar si hay una URL de redirección pendiente
      const redirectUrl = searchParams.get('redirect')
      if (redirectUrl) {
        navigate(redirectUrl, { replace: true })
      } else {
        navigate('/home', { replace: true })
      }
    } catch (err) {
      console.error('Error al configurar usuario:', err)
      setError('Error al guardar la configuración. Intenta de nuevo.')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="login-page">
      <style>{`
        .config-card {
          background-color: #ffffff;
          border-radius: 24px;
          padding: 32px;
          width: 100%;
          max-width: 400px;
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.04);
        }
        .config-form-group {
          margin-bottom: 20px;
        }
        .config-form-label {
          display: block;
          margin-bottom: 8px;
          font-weight: 500;
          font-size: 14px;
          color: #1a1a1a;
        }
        .config-input {
          width: 100%;
          padding: 14px 16px;
          font-size: 16px;
          color: #1a1a1a;
          background-color: #ffffff;
          border: 1px solid #e0e0e0;
          border-radius: 12px;
          font-family: inherit;
          transition: border-color 0.2s;
          box-sizing: border-box;
        }
        .config-input::placeholder {
          color: #999;
        }
        .config-input:focus {
          outline: none;
          border-color: #1a1a1a;
        }
        .config-error {
          color: #e74c3c;
          font-size: 14px;
          margin-top: 8px;
        }
        .config-btn {
          width: 100%;
          padding: 14px 20px;
          font-size: 15px;
          font-weight: 500;
          color: white;
          background-color: #1a1a1a;
          border: none;
          border-radius: 12px;
          cursor: pointer;
          transition: background-color 0.2s;
          margin-top: 8px;
        }
        .config-btn:hover:not(:disabled) {
          background-color: #333;
        }
        .config-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
        }
      `}</style>
      <div className="login-container">
        <div className="logo-container">
          <img src="/logosinnombresinfondo.png" alt="Logo" className="logo" />
        </div>

        <div className="divider"></div>

        <div className="config-card">
          <h2 style={{ fontSize: '24px', fontWeight: '600', marginBottom: '24px', color: '#1a1a1a', textAlign: 'center' }}>
            Completa tu perfil
          </h2>
          <form onSubmit={(e) => { e.preventDefault(); handleContinue(); }}>
            <div className="config-form-group">
              <label className="config-form-label" htmlFor="name">Nombre</label>
              <input
                type="text"
                id="name"
                className="config-input"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Escribe tu nombre"
                required
                disabled={isLoading}
              />
            </div>

            {error && (
              <p className="config-error">
                {error}
              </p>
            )}

            <button
              type="submit"
              className="config-btn"
              disabled={!name.trim() || isLoading}
            >
              {isLoading ? "Configurando..." : "Continuar"}
            </button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default SetDisplayName